import { Card, Typography, CardContent, Box } from '@mui/material';
import { Link } from "react-router";
import { location } from '../../assets/images/svgs';
import { Promotion } from './components/PromotionBanner';
import { Header } from './components/Header';
import { TopBanner } from './components/TopBanner';
import { Services } from './components/Services';
import { Address } from './components/Address';
import { Article1 } from './components/Article1'
import { Article2 } from './components/Article2'
import { styled } from '@mui/system';

const BodyContainer = styled('div')((props) => ({
    // paddingTop: 125,
    [props.theme.breakpoints.down('sm')]: {
        // paddingTop: 145
    }

}))


const bannerArray=[
    {title:'About Day Care',link:'/about-day-care'},
    {title:'World Of Dogs',link:'/world-of-dogs'},
    {title:'Dog breed Guide',link:'/dog-breed-guide'},
    {title:'Traveling With Dog',link:'/traveling-with-dog'},
    {title:'Dog Training',link:'/dog-training'},
    {title:'Dog Behaviour',link:'/dog-behaviour'},
    {title:'Adopting A Dog',link:'/adopting-dog'}

]

export const Home = () => {
    return (
        <div>
            <div style={{
                position: 'fixed',
                width: '100%',
                top: 0,
                marginBottom: 100
            }}>
                {/* <Promotion /> */}
                <Header />
                <Address />
            </div>
            <BodyContainer>
                <TopBanner />
                <Typography variant="h4" style={{margin:20, textAlign:'center'}}>Our Blogs</Typography>
                <Box
      sx={{
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(250px, 100%), 2fr))',
        gap: 2,
      }}>
                {bannerArray.map(({title, link})=>(
                     <Link to={link} style={{textDecoration:'none'}}>
                    <Card>
                    <CardContent sx={{ height: '100%'}}>
                        <Typography variant="h5" component="div" style={{textAlign:'center'}}>{title}</Typography>
                        </CardContent>
                    </Card>
                    </Link>
                ))}
                </Box>
                
                <Services />
            </BodyContainer>
        </div>
    );
}










